// extracted by mini-css-extract-plugin
export default {"container":"ScoreTable_container__fCqJb"};